import { render, staticRenderFns } from "./HeadAction.vue?vue&type=template&id=b13684b6&scoped=true"
import script from "./HeadAction.vue?vue&type=script&lang=js"
export * from "./HeadAction.vue?vue&type=script&lang=js"
import style0 from "./HeadAction.vue?vue&type=style&index=0&id=b13684b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13684b6",
  null
  
)

export default component.exports